import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import ChildRegistrationFormComp from '../../../../components/registrationPacket/ChildRegistrationFormComp';

const ChildRegistrationForm = () => {
  return (
    <Container>
      <Row>
        <Col sm={12}>
          <ChildRegistrationFormComp />
        </Col>
      </Row>
    </Container>
  );
};

export default ChildRegistrationForm;
